import type { TOC } from '@ember/component/template-only';
import { PrismModal } from '@mylighthouse/prism-ember';
import { t } from 'ember-intl';
import GeneralButtonsButtonExport from 'lumen/components/general/buttons/button-export';
import HotelAndMarketRevenueInsightTabsTabSegmentationTable from 'lumen/components/hotel-and-market/revenue-insight/tabs/tab-segmentation-table';
import type MarketRevenueInsightBreakdownDetailController from 'lumen/controllers/market/revenue-insight/breakdown-detail';

interface MarketRevenueInsightBreakdownDetailSignature {
  Args: {
    controller: MarketRevenueInsightBreakdownDetailController;
    model: unknown;
  };
}

<template>
  <PrismModal
    @onClose={{@controller.redirectOnClose}}
    @title={{@controller.modalTitle}}
  >
    <:actions>
      <GeneralButtonsButtonExport
        @disabledMessage={{t
          "revenue_insight.export.unavailable_for_percentage_view"
        }}
        @exportAction={{@controller.triggerExcelExportFromModal}}
        @isDisabled={{@controller.riSelections.isCancellationsPercentageView}}
      />
    </:actions>

    <:default>
      <div class="ri-modal modal--stretched">
        <HotelAndMarketRevenueInsightTabsTabSegmentationTable
          @filterText={{@controller.filterText}}
          @params={{@controller.detailTabParams}}
        />
      </div>
    </:default>
  </PrismModal>
</template> satisfies TOC<MarketRevenueInsightBreakdownDetailSignature>;
